module.exports = __webpack_public_path__ + "img/Arrow.74010b98.svg";